import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function TeamShortTermGoalsListItem({stg, display_stg}) 
{
    const { short_term_goal } = useCTAL();

    if (!stg) return;
    
    var stg_style = { color: 'black' };
    if (stg === short_term_goal) stg_style = { color: '#0d6efd' };

    //const CreatedDT = new Date(stg.CreatedAt);
    //const formattedDate = CreatedDT.toLocaleString("en-US", { day: "numeric", month: "short", year: "numeric", });  

    var deadline_date_txt = stg.DeadlineDate;
    if (deadline_date_txt.length <= 0) deadline_date_txt = "*No Value*"; //YYYY-MM-DD = 10 chars

    return (
        <>
            <option value={stg.Goal} style={stg_style} onClick={ () => display_stg(stg) } >{deadline_date_txt} {stg.Goal}</option>
        </>
    );
}